exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* banner section */\n\n.banner img {\n    height: 40px;\n    width: 100%\n}\n\n.hide-banner {\n    position: absolute;\n    z-index: 1;\n    right: 15px;\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n    background: transparent url('/assets/images/x.png') center no-repeat;\n    background-size: 15px auto;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/MartMax/components/home-page/header-banner/header-banner.component.css
// module id = ../../../../../src/app/MartMax/components/home-page/header-banner/header-banner.component.css
// module chunks = main